import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';
import dayjs from 'dayjs';
import { FORMAT_DATE_TIME } from '../../utils/constants';
import i18next from 'i18next';
import { translateSfAccountsTypes } from '../../utils/translations';

const columnsArray = [
	{
		accessor: 'RecordType.Name',
		id: 'Type',
		Header: i18next.t('type'),
		disableSortBy: true,
		Cell: (({ value }) => {
			return translateSfAccountsTypes(value)
		})
	},
	{
		accessor: 'Name',
		id: 'Name',
		Header: i18next.t('name'),
		disableSortBy: true,
	},
	{
		accessor: 'CreatedDate',
		id: 'CreatedDate',
		Header: i18next.t('date'),
		Cell: (({ value }) => {
			const date = dayjs(value);
			return date.format(FORMAT_DATE_TIME)
		})
	},
	{
		accessor: 'Phone',
		id: 'Phone',
		Header: i18next.t('phone'),
		disableSortBy: true,
	},
	{
		accessor: 'Partita_IVA__c',
		id: 'Partita_IVA__c',
		Header: i18next.t('business_fiscal_code'),
		disableSortBy: true,
	}, {
		accessor: 'Codice_Fiscale__c',
		id: 'Codice_Fiscale__c',
		Header: i18next.t('fiscal_code'),
		disableSortBy: true,
	},
	{
		accessor: 'Email__c',
		id: 'Email__c',
		Header: i18next.t('email'),
		disableSortBy: true,
	},
	{
		width: 60,
		accessor: 'actions',
		id: 'actions',
		Header: '',
		disableSortBy: true,
		headerClassName: 'column-sticky',
		className: 'column-sticky text-end',
		Cell: (data: any) => {
			return (
				<Link
					to={`/my-accounts/${data.row.original.Id}`}
					className="btn"
				>
					<Icon
						style={{ width: '1.2rem', height: '1.2rem' }}
						name="arrow-right"
					/>
				</Link>
			)
		},
	},
];

export default columnsArray;
